// extracted by mini-css-extract-plugin
export default {"rating":"MJ-z","numberOfStars":"NJ-z","count":"OJ-z","barGraphSpacing":"PJ-z","barGraph":"QJ-z"};